import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography, Button, Row, Col, Table, Card } from "antd";
import { CheckCircleFilled, ClockCircleOutlined } from "@ant-design/icons";
import "../Styles/UserStylings/Confirmation.css";

const { Title, Text } = Typography;

const Confirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { cart, total, paymentId, orderId, date, orderNumber,paymentType, status } = location.state || {};

  const isPayAtStore = paymentType === "pay_at_store" || status === "failed";
  const headerColor = isPayAtStore ? "#ff9f00" : "#43be31";
  const headerText = isPayAtStore ? "Pending Payment (Pay at Store)" : "Payment Successful!";
  const subText = isPayAtStore
    ? "Please visit the store to complete your payment and collect your order."
    : "Your payment has been completed successfully.";

  // Table columns
  const columns = [
    { title: "Product", dataIndex: "name", key: "name", responsive: ["xs", "sm", "md", "lg"] },
    { title: "Quantity", dataIndex: "quantity", key: "quantity", align: "center", responsive: ["sm", "md", "lg"] },
    { title: "Price", dataIndex: "price", key: "price", align: "center", responsive: ["sm", "md", "lg"] },
    { title: "Subtotal", dataIndex: "subtotal", key: "subtotal", align: "center", responsive: ["sm", "md", "lg"] },
  ];

  const dataSource = (cart || []).map((item) => ({
    key: item.id,
    name: item.product?.name,
    quantity: item.quantity,
    price: item.product ? `₹${item.product.price}` : "-",
    subtotal: item.product ? `₹${item.quantity * item.product.price}` : "-",
  }));

  return (
    <div style={{ background: "#f6f8fb", minHeight: "100vh", padding: "16px 0 48px 0" }}>
      {/* Header */}
      <div
        style={{
          background: "#1129ce",
          padding: "32px 16px",
          textAlign: "center",
          borderRadius: "0 0 18px 18px",
          marginBottom: 24,
        }}
      >
        {isPayAtStore ? (
          <ClockCircleOutlined style={{ fontSize: 42, color: headerColor, marginBottom: 10 }} />
        ) : (
          <CheckCircleFilled style={{ fontSize: 42, color: headerColor, marginBottom: 10 }} />
        )}
        <Title level={3} style={{ color: "#fff", marginBottom: 8 }}>
          {headerText}
        </Title>
        <Text style={{ color: "#e5f3ff", fontSize: 14 }}>{subText}</Text>
      </div>

      {/* Payment & Store Info */}
      <Row
        gutter={[16, 16]}
        style={{ maxWidth: 1100, margin: "0 auto", padding: "0 16px" }}
      >
        <Col xs={24} md={12}>
          <Card
            bordered={false}
            style={{ padding: 20, borderRadius: 16 }}
          >
            <Title level={5} style={{ color: "#1129ce", fontWeight: 700 }}>Payment Info</Title>
           <Text>
  <b>Payment ID:</b> {paymentId || (isPayAtStore ? "Not Paid Yet" : "-")}
</Text><br />

<Text>
  <b>Order Number:</b> <span style={{ color: "#1129ce", fontWeight: 600 }}>
    {orderNumber || orderId || "-"}
  </span>
</Text><br />

<Text>
  <b>Date:</b> {date || "-"}
</Text><br />

<Text>
  <b>Total Amount:</b>{" "}
  <span style={{ color: "#1129ce", fontWeight: 600 }}>
    {total ? `₹${total}` : "-"}
  </span>
</Text><br />

<Text>
  <b>Payment Method:</b> {paymentType || "Online"}
</Text>

          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card
            bordered={false}
            style={{ padding: 20, borderRadius: 16 }}
          >
            <Title level={5} style={{ color: "#1129ce", fontWeight: 700 }}>Store Details</Title>
            {cart && cart[0]?.product?.seller ? (
              <Text style={{ fontWeight: 500, color: "#333" }}>
                {[cart[0].product.seller.store_name, cart[0].product.seller.store_street, cart[0].product.seller.store_area, cart[0].product.seller.store_city, cart[0].product.seller.store_pincode].filter(Boolean).join(", ")}
              </Text>
            ) : (
              <Text>No store information available.</Text>
            )}
          </Card>
        </Col>
      </Row>

      {/* Purchased Items */}
      {/* Purchased Items */}
<div style={{ maxWidth: 1100, margin: "24px auto", padding: "0 16px" }}>
  <Card style={{ borderRadius: 16, padding: 16 }}>
    <Title level={5} style={{ color: "#172839" }}>Purchased Items</Title>
    
    {/* Scrollable container for mobile */}
    <div style={{ overflowX: "auto", width: "100%" }}>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        bordered={false}
        size="small"
        style={{ minWidth: 500 }} // ensures table doesn’t shrink too much
      />
    </div>
  </Card>
</div>


      {/* Action Buttons */}
      <Row justify="space-between" gutter={[16, 16]} style={{ maxWidth: 1100, margin: "24px auto", padding: "0 16px" }}>
        <Col xs={24} sm={12}>
          <Button type="primary" block size="large" style={{ background: "#1129ce", fontWeight: 600 }} onClick={() => navigate("/")}>
            Go Home
          </Button>
        </Col>
        <Col xs={24} sm={12}>
          <Button block size="large" style={{ background: "#f7f7fb", color: "#172839", border: "1.5px solid #1129ce", fontWeight: 600 }} onClick={() => navigate("/my-account")}>
            View Profile
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Confirmation;
